import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const DocumentListContainer = styled(Flex)(({ theme }) => ({
  marginTop: theme.spacing(12),
  overflow: 'auto',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: theme.spacing(10),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    overflow: 'none',
  },
}));
